import { Button, Tooltip, message } from 'antd';
import React from 'react';
import { MdContentCopy } from 'react-icons/md';

const copyToClipboard = (text) => {
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text);
  } else {
    let textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'absolute';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    return new Promise((res, rej) => {
      document.execCommand('copy') ? res() : rej();
      textArea.remove();
    });
  }
};

const CopyElement = ({ text }) => {
  return (
    <Tooltip title="Kopyala" placement="top">
      <Button
        icon={<MdContentCopy style={{ top: 2 }} />}
        type="link"
        className="copy-element"
        onClick={() => {
          copyToClipboard(text).then(function () {
            message.success(`${text} kopyalandı!`);
          });
        }}
      />
    </Tooltip>
  );
};

export default CopyElement;
